import { TwoFAType } from 'data/Auth/types'
import { ChangePasswordFormType } from 'data/Form/ChangePassword/types'
import { ForgotPasswordFormType } from 'data/Form/ForgotPassword/types'
import { PasswordStrengthResponseType } from 'data/Form/Signup/types'
import { TwoFactorFormType } from 'data/Form/TwoFactor/types'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

export const refreshToken = (tokenInResponse = false) =>
  fetchApi<{ csrfToken: string; sessionExpirationTime: number; token?: string }>({
    auth: true,
    method: 'POST',
    url: getApiUrl(`nabu-gateway/token/refresh${tokenInResponse ? '?tokenInResponse' : ''}`)
  })

export const getPasswordStrength = (body: { newPassword?: string }) =>
  fetchApi<PasswordStrengthResponseType>({
    body: {
      password: body.newPassword
    },
    method: 'POST',
    url: getApiUrl('nabu-gateway/password/strength')
  })

export const changePassword = (body: ChangePasswordFormType) =>
  fetchApi<void>({
    auth: true,
    body: {
      newPassword: body.newPassword,
      password: body.oldPassword
    },
    method: 'POST',
    url: getApiUrl('nabu-gateway/password')
  })

export const resetPassword = (body: { resetCode: string } & ForgotPasswordFormType) =>
  fetchApi<void>({
    body: {
      newPassword: body.newPassword
    },
    method: 'PUT',
    url: getApiUrl(`nabu-gateway/password/reset/${body.resetCode}`)
  })

export const sendResetPasswordEmail = (body: ForgotPasswordFormType) =>
  fetchApi<void>({
    body: {
      email: body.email
    },
    method: 'POST',
    url: getApiUrl('nabu-gateway/password/reset/create')
  })

export const signout = () =>
  fetchApi<void>({
    auth: true,
    method: 'POST',
    url: getApiUrl('nabu-gateway/signout')
  })

export const verifyPassword = (body: TwoFactorFormType) =>
  fetchApi<void>({
    auth: true,
    body: {
      password: body.password
    },
    method: 'POST',
    url: getApiUrl('nabu-gateway/password/verify')
  })

export const createChallenge = () =>
  fetchApi<{ challengeId: string; twoFaType: TwoFAType }>({
    auth: true,
    method: 'POST',
    url: getApiUrl('nabu-gateway/users/two-factor-auth/challenge')
  })
